// FILE: src/components/RecentSessionsCard.js
//
// Last 5 sessions in the primary column. Each row: date, mode, score.

import React from 'react';
import DashCard from './DashCard';
import styles from './RecentSessionsCard.module.css';

export default function RecentSessionsCard({ sessions = [], onViewHistory }) {
  const recent = (sessions || []).slice(0, 5);

  if (recent.length === 0) {
    return (
      <DashCard eyebrow="Recent Sessions" eyebrowIcon="📈" testId="dashboard-recent-sessions">
        <div className={styles.empty}>No sessions yet — your first one will land here.</div>
      </DashCard>
    );
  }

  return (
    <DashCard eyebrow="Recent Sessions" eyebrowIcon="📈" testId="dashboard-recent-sessions">
      <ul className={styles.list}>
        {recent.map((s) => {
          const d = new Date(s.startedAt);
          const date = Number.isFinite(d.getTime())
            ? d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
            : '—';
          const score = typeof s.scorePercentage === 'number' ? `${Math.round(s.scorePercentage)}%` : '—';
          return (
            <li key={s.sessionId} className={styles.row}>
              <span className={styles.day}>{date}</span>
              <span className={styles.mode}>{prettyMode(s.mode)}</span>
              <span className={scoreClass(s.scorePercentage, styles)}>{score}</span>
            </li>
          );
        })}
      </ul>
      {onViewHistory && (
        <button type="button" className={styles.link} onClick={onViewHistory} data-testid="dashboard-view-history">
          View performance history ›
        </button>
      )}
    </DashCard>
  );
}

function prettyMode(m) {
  const s = (m || '').replace(/_/g, ' ');
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : '—';
}

function scoreClass(pct, styles) {
  if (typeof pct !== 'number') return styles.scoreMuted;
  if (pct >= 75) return styles.scoreGood;
  if (pct < 50)  return styles.scoreBad;
  return styles.scoreMid;
}
